import Api from "~/service/Api";

class TourInboxImageUploadNotifyRepository {
  notify(payload) {
    return Api.post("/tour-inbox-images/upload-notify", payload);
  }
}

export default TourInboxImageUploadNotifyRepository;
